const fields = [
    {label: "Sidetittel", name: "title", errMsg: "Du må oppgi en tittel"},
    {label: "Sidesti", name: "path", errMsg: "Du må oppgi en sti"},
];

export default fields;